import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../../svg/logo';
import { Matrix } from '../../svg/matrix';
import { ProductionPanel } from '../production-panel';
import { Dropdown, Menu } from '@arco-design/web-react';
import { IconCaretDown } from '@arco-design/web-react/icon';
import { LanguageContext } from '../../utils';

import './index.less';

interface IProps {
  title?: React.ReactNode;
  style?: React.CSSProperties;
  left?: (React.ReactNode | { type: 'custom'; node: React.ReactNode })[];
  right?: React.ReactNode[];
  className?: string;
}

type DropdownLinkItem = {
  href: string;
  key: string;
  label: string;
};

export function DropdownLink(props: {
  label: string;
  linkList: DropdownLinkItem[];
  selected?: string;
}) {
  const { label, linkList, selected } = props;
  const navigate = useNavigate();

  const dropdownList = (
    <Menu className="navigator-link-dropdown-menu">
      {linkList.map((link) => {
        return (
          <Menu.Item key={link.key}>
            <a
              href={link.href}
              {...(selected === link.key
                ? {
                    className: 'navigator-link-selected',
                    onClick: (event) => {
                      navigate(link.href);
                      event.preventDefault();
                    },
                  }
                : {
                    onClick: (event) => {
                      navigate(link.href);
                      event.preventDefault();
                    },
                  })}
            >
              {link.label}
            </a>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  const isSelected = linkList.some((link) => link.key === selected);
  return (
    <Dropdown droplist={dropdownList} position="bottom">
      <div style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
        <div className="navigator-link">
          <a
            className={isSelected ? 'navigator-link-selected' : ''}
            href={linkList[0].href}
            onClick={(event) => {
              // default navigate to first link
              navigate(linkList[0].href);
              event.preventDefault();
            }}
          >
            {label}
            <IconCaretDown style={{ paddingLeft: 2 }} />
          </a>
        </div>
      </div>
    </Dropdown>
  );
}

export function Navigator() {
  let timer: any = null;
  return (props: IProps) => {
    const navigate = useNavigate();
    const { language } = useContext(LanguageContext);
    const [dropDown, setDropDown] = useState<boolean>(false);

    return (
      <div
        className="navigator-container"
        style={{ zIndex: 1, ...(props.style ?? {}) }}
      >
        <div className="navigator-left">
          <div
            style={{
              marginRight: 16,
              cursor: 'pointer',
              paddingTop: 14,
              paddingBottom: 16,
              height: 48,
            }}
            onMouseEnter={() => {
              if (timer) {
                clearTimeout(timer);
                timer = null;
              }
              setDropDown(true);
            }}
            onMouseLeave={() => {
              if (timer) {
                clearTimeout(timer);
                timer = null;
              }
              timer = setTimeout(() => setDropDown(false), 500);
            }}
          >
            <Matrix
              style={{ width: 16, height: 16 }}
              color={dropDown ? '#3073F2' : 'rgba(20, 20, 20, 0.9)'}
            />
          </div>
          <div
            style={{ marginRight: 8, cursor: 'pointer', display: 'flex' }}
            onClick={() => navigate('/')}
          >
            <Logo href="/" style={{ height: 24, width: 24, marginRight: 10 }} />
            <a
              href="/"
              className="navigator-title"
              style={{
                height: 24,
                lineHeight: '24px',
              }}
              onClick={(event) => event.preventDefault()}
            >
              VisActor
            </a>
          </div>
          {props.title ? (
            <>
              <div
                style={{
                  marginRight: 8,
                  borderLeft: '1px solid #1B1F23',
                  opacity: 0.08,
                  height: 14,
                }}
              ></div>
              <div
                className="navigator-title"
                style={{
                  marginRight: 32,
                  whiteSpace: 'nowrap',
                }}
              >
                {props.title}
              </div>
            </>
          ) : (
            <div style={{ marginRight: 74 }}></div>
          )}
          {(props.left ?? []).map((node, index) =>
            (node as any).type === 'custom' ? (
              (node as any).node
            ) : (
              <div key={index} className="navigator-link">
                {node as React.ReactNode}
              </div>
            )
          )}
        </div>
        <div className="navigator-right">
          {(props.right ?? []).map((node, index) => (
            <div key={index} className="navigator-tool">
              {node}
            </div>
          ))}
        </div>
        <ProductionPanel
          dropDown={dropDown}
          onMouseEnter={() => {
            if (timer) {
              clearTimeout(timer);
              timer = null;
            }
            setDropDown(true);
          }}
          onMouseLeave={() => {
            if (timer) {
              clearTimeout(timer);
              timer = null;
            }
            timer = setTimeout(() => setDropDown(false), 500);
          }}
          style={{ position: 'absolute', top: 48, left: 0 }}
        />
      </div>
    );
  };
}
